import { useMutation } from '@gogame/query';

import { addPromoCode } from 'scenes/Influencers/InfluencersCampaigns/sources/influencersCampaigns';

import { batchAddPromoCode } from '../queryKeyFactory';

export const useBatchAddPromoCode = () => {
  const batchAddPromoCodeMutation = useMutation(
    batchAddPromoCode(),
    addPromoCode,
    {
      successMessage: () => `Promo Code added`, //TODO: check label with o.bagmet
    }
  );

  return [batchAddPromoCodeMutation.mutateAsync, batchAddPromoCodeMutation];
};
